import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
import _imports_0 from '@/assets/arrow-right.png';
const _hoisted_1 = { class: "sectionHeader" };
const _hoisted_2 = { class: "title-subtitle" };
const _hoisted_3 = { class: "title" };
const _hoisted_4 = {
    key: 0,
    class: "subtitle"
};
const _hoisted_5 = {
    key: 1,
    class: "right-label"
};
export default /*@__PURE__*/ _defineComponent({
    __name: 'SectionHeader',
    props: {
        title: {},
        subtitle: {},
        rightLabel: {},
        actionLabel: {}
    },
    emits: ["action"],
    setup(__props) {
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("h2", _hoisted_3, _toDisplayString(_ctx.title), 1),
                    (_ctx.subtitle)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(_ctx.subtitle), 1))
                        : _createCommentVNode("", true)
                ]),
                (_ctx.actionLabel)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: "action",
                        onClick: _cache[0] || (_cache[0] = ($event) => (_ctx.$emit('action')))
                    }, [
                        _createElementVNode("span", null, _toDisplayString(_ctx.actionLabel), 1),
                        _cache[1] || (_cache[1] = _createElementVNode("img", {
                            src: _imports_0,
                            alt: "arrow"
                        }, null, -1))
                    ]))
                    : _createCommentVNode("", true),
                (_ctx.rightLabel)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                        _createElementVNode("span", null, _toDisplayString(_ctx.rightLabel), 1)
                    ]))
                    : _createCommentVNode("", true)
            ]));
        };
    }
});
